import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './ProgressEvaluation.module.scss'
import { getPercentage } from 'helpers'

interface Progress {
  approved: number
  reproved: number
}

interface ProgressEvaluationProps {
  progress: Progress
  total: number
  text?(percentages: Progress): ReactNode
}

export const ProgressEvaluation = ({
  progress,
  total,
  text,
}: ProgressEvaluationProps) => {
  const { approved, reproved } = progress

  const percentages = {
    approved: getPercentage(approved, total),
    reproved: getPercentage(reproved, total),
  }
  return (
    <>
      <div className={classNames(styles.progressBar)}>
        <div
          style={{ width: percentages.approved + '%' }}
          className={classNames(styles.progress, styles.approved)}
        />
        <div
          style={{ width: percentages.reproved + '%' }}
          className={classNames(styles.progress, styles.reproved)}
        />
        <div
          style={{
            width: 100 - (percentages.approved + percentages.reproved) + '%',
          }}
          className={classNames(styles.progress, styles.inProgress)}
        />
      </div>
      {text?.(percentages)}
    </>
  )
}
